import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { RouteService } from 'services/route.service';
import Text from 'components/Text/Text';
import { getDriverOrderPDFStates } from 'store/orderDetailPDF/action';
import { getBuyPermitGetPermitNumber, hideBuyPermitThankYouModal } from 'store/buyPermits/action';
import { getOrderCompletePageEditorSelector } from 'store/profile/selector';
import { getCustomer } from 'store/home/selector';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'block',
    margin: '0 auto 250px',
    width: '80%',

    [theme.breakpoints.up('md')]: {
      marginBottom: '150px',
      width: '50%',
    },
  },
  title: {
    fontSize: '30px',
    fontWeight: 500,
    textAlign: 'center',
    color: 'black'
  },
  bodyWrapper: {
    borderTop: '1px solid gray',
    marginTop: '-20px',
    textAlign: 'center',
    color: 'black',
    paddingTop: '20px',
  },
  printButton: {
    backgroundColor: '#20419a',
    color: 'white',
    borderRadius: '8px',
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '30px',
    '& a': {
      textDecoration: 'none',
    }
  }
}));

const PermitPaymentStatus = ({
  onPlaceAnotherOrder
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const group = useSelector(getCustomer);
  const paymentDetails = useSelector((state) => state?.exitOrderReducer?.buyPemitOrderPayment);
  const orderCompletePageEditorData = useSelector(getOrderCompletePageEditorSelector);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('RYDIN_REFERENCE');

    if (orderId) {
      dispatch(getBuyPermitGetPermitNumber(orderId))
    }
  }, [location.search]);

  const formatDate = (dateStr) => {
    if (!dateStr) return undefined;
    const date = new Date(dateStr);
    return isNaN(date)
      ? undefined
      : `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const handlePdfView = () => {
    if (!paymentDetails?.id) return;
    dispatch(getDriverOrderPDFStates({ OrderId: paymentDetails.id }));
  };

  const handleReturnToHome = () => {
    dispatch(hideBuyPermitThankYouModal());
    history.push({ pathname: `${RouteService.home(group)}/dashboard` });
  };

  const handlePlaceAnotherOrder = () => {
    if (onPlaceAnotherOrder) {
      onPlaceAnotherOrder();
    } else {
      history.push({ pathname: `${RouteService.buyPermits(group)}` });
    }
  }

  const isOfflinePayment = (method) => ["CASH", "CHECK", "OTHER", undefined].includes(method);

  if (!paymentDetails) return null;

  const { payment, id: orderId, orderDate, total, confirmationEmailAddress } = paymentDetails;
  const isOffline = isOfflinePayment(payment?.paymentMethod);

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>
        Thank you!
      </h1>

      <div className={classes.bodyWrapper}>
        <Text>
          {isOffline
            ? "Your Payment is due"
            : "Your Payment has been received"}
        </Text>
        <br />
        <Text>
          Confirmation #: <b>{orderId}</b>
        </Text>
        <br />
        <Text>
          Amount Paid: <b>${isOffline ? "0.00" : total.toFixed(2)}</b>
        </Text>
        <br />
        <Text>
          Payment Date: <b>{formatDate(orderDate)}</b>
        </Text>
        <br />
        <Text>
          <b>A confirmation email has been sent to {confirmationEmailAddress?.address}</b>
        </Text>
        <br />

        {orderCompletePageEditorData?.text && (
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: orderCompletePageEditorData }}
          />
        )}

        {!isOffline && (
          <Button className={classes.printButton} variant="contained" onClick={handlePdfView}>
            PRINT CONFIRMATION
          </Button>
        )}
      </div>

      <div className={classes.footerWrapper}>
        <Button color="primary" onClick={handleReturnToHome}>
          Return home
        </Button>
        <Button color="primary" onClick={handlePlaceAnotherOrder}>
          Place another Order
        </Button>
      </div>
    </div>
  )
};

export default PermitPaymentStatus;